import React from "react";
import "./Product.css";

export default function ServiceGrid() {
  // ====== TÙY CHỈNH DỮ LIỆU / ĐƯỜNG DẪN ẢNH TẠI ĐÂY ======
  const services = [
    {
      id: 1,
      name: "Sửa Máy Lạnh",
      img: "/dieuhoa.png", // ← đổi src ảnh
    },
    {
      id: 2,
      name: "Sửa Tivi",
      img: "/tivi.png",
    },
    {
      id: 3,
      name: "Sửa Tủ Lạnh",
      img: "/tulanh.png",
    },
    {
      id: 4,
      name: "Sửa Máy Giặt",
      img: "/maygiat.png",
    },
    {
      id: 5,
      name: "Sửa Máy Nước Nóng",
      img: "/maynuocnong.png",
    },
    {
      id: 6,
      name: "Sửa Lò Vi Sóng",
      img: "/lovisong.png",
    },
    {
      id: 7,
      name: "Sửa Lò Nướng",
      img: "/lonuong.png",
    },
    {
      id: 8,
      name: "Sửa Máy Sấy Quần Áo",
      img: "/maysayquanao2.png",
    },
  ];
  // =====================================================

  return (
    <section className="svc-section">
      <div className="svc-container">
        <h2 className="svc-title">
          Bạn muốn yêu cầu dịch vụ bảo trì sửa chữa sản phẩm nào?
        </h2>
        <p className="svc-subtitle">
          Vui lòng chọn loại sản phẩm của bạn
        </p>

        <div className="svc-card-grid">
          {services.map((item) => (
            <button
              key={item.id}
              className="svc-card"
              type="button"
              // onClick={() => ... điều hướng form, v.v.}
            >
              <div className="svc-card-img-wrap">
                <img src={item.img} alt={item.name} />
              </div>
              <div className="svc-card-name">{item.name}</div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}